export function formatCPF(value = "") {
  return value.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "$1.$2.$3-$4");
}

export function formatCreditCard(value = "") {
  return value.replace(/(\w{4})(\w{4})(\w{4})(\w{4})/g, "$1 $2 $3 $4");
}

export function formatCelular(cel) {
  const parte1 = cel.slice(0, 5);
  const parte2 = cel.slice(5, 9);

  return `${parte1}-${parte2}`;
}

export function formatLastFourCardNumber(cardNumber) {
  if (!cardNumber) {
    return "";
  }

  if (typeof cardNumber !== "string") {
    return cardNumber;
  }

  return cardNumber
    .match(/.{1,4}/g)
    .join(" ")
    .replace(/X/g, "*");
}
